import { ApiResponse } from "helpers/fetch-wrapper";
import { getBusinessDetailsQuery, setBusinessBankAccountQuery, TeamQueries } from "queries/misc-queries";

export interface Team {
    id: string;
    username: string;
    email?: string;
    phone_number?: string;
    is_business_owner?: boolean;
}

export async function getTeamList() {
    try {
        // const response = await fetch("https://jsonplaceholder.typicode.com/users");
        const response = await TeamQueries.getTeamList();
        const data: Team[] = await response.json();

        const apiResponse: ApiResponse<Team[]> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<Team[]> = {
            body: [],
            message: 'Failed to get Team Members, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }
}


export async function createTeamMember(user: any) {
    try {
        const response = await TeamQueries.createTeamMember(user);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 201 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: [],
            message: 'Failed to create Team Member, An error occurred',
            error: 'Failed to create Team Member, An error occurred',
            status: 500,
        }

        return apiResponse
    }
}

export async function deleteTeamMember(id: string) {
    try {
        const response = await TeamQueries.deleteTeamMember(id);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to delete Team Member, An error occurred',
            error: 'Failed to delete Team Member, An error occurred',
            status: 500,
        }

        return apiResponse
    }
}

export interface BusinessDetails {
    name: string;
    address: string;
    phone_number: string;
    email: string;
    bank_account: {
        name: string;
        account_number: string;
        bank_name: string;
    }
}

export async function getBusinessDetailsAction() {
    try {
        const response = await getBusinessDetailsQuery();
        const data: BusinessDetails = await response.json();

        const apiResponse: ApiResponse<BusinessDetails> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to get Business Details, An error occurred',
            error: 'Failed to get Business Details, An error occurred',
            status: 500,
        }

        return apiResponse
    }
}

export async function setBusinessBankAccountAction(bankDetails: any) {
    try {
        const response = await setBusinessBankAccountQuery(bankDetails);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 201 ? null : data['message'],
        }

        return apiResponse
    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to set Business Bank Details, An error occurred',
            error: 'Failed to set Business Bank Details, An error occurred',
            status: 500,
        }

        return apiResponse
    }
}

